import React from 'react'
import PropTypes from 'prop-types';
import moment from 'moment';
import cookie from 'react-cookies'
import theme from './Header.scss'
import BaseComponent from '../BaseComponent';

export default class Header extends BaseComponent {

    render() {
        return (
            <header>
                <div>
                    <h1>{this.props.value}</h1>
                    {this.renderSupportInfo()}
                    {this.props.children}
                </div>
            </header>
        )
    }

    renderSupportInfo = () => {
        const supportToken = cookie.load('support_token');
        if (supportToken) {
            const serverNode = this.getCookie('ROUTEID') || "";
            return (
                <div className={theme.supportInfo}>
                    Support Info: {moment(new Date()).format('YYYY-MM-DD HH:mm:ss') + " " + supportToken + " " + serverNode}
                </div>
            );
        }
    }
}

Header.PropTypes = {
    /**
     * Header value.
     */
    value: PropTypes.string.isRequired
};


// WEBPACK FOOTER //
// ./src/common/Header/index.js